import { UILocale, UILocaleInfo } from '../types';
import { vi } from './vi';
import { en } from './en';
import { LOCALE_STORAGE_KEY } from '../constants/storageKeys';

const LOCALES: Record<UILocale, Record<string, string>> = { vi, en };

const LOCALE_INFO: UILocaleInfo[] = [
  { code: 'vi', name: 'Tiếng Việt', nativeName: 'Tiếng Việt' },
  { code: 'en', name: 'English', nativeName: 'English' },
];

export class I18nService {
  private currentLocale: UILocale = 'vi';
  private currentStrings: Record<string, string> = vi;
  private fallbackStrings: Record<string, string> = vi;

  onLocaleChanged: ((locale: UILocale) => void) | null = null;

  initialize(locale?: UILocale): void {
    const saved = this.loadSavedLocale();
    const targetLocale = locale || saved || 'vi';
    this.setLocaleInternal(targetLocale);
  }

  setLocale(locale: UILocale): void {
    if (locale === this.currentLocale) return;
    this.setLocaleInternal(locale);
    this.saveLocale(locale);
    if (this.onLocaleChanged) {
      this.onLocaleChanged(locale);
    }
  }

  getLocale(): UILocale {
    return this.currentLocale;
  }

  t(key: string, params?: Record<string, string | number>): string {
    let text = this.currentStrings[key] ?? this.fallbackStrings[key] ?? key;
    if (params) {
      for (const [k, v] of Object.entries(params)) {
        text = text.replace(new RegExp(`\\{${k}\\}`, 'g'), String(v));
      }
    }
    return text;
  }

  getSupportedLocales(): UILocaleInfo[] {
    return [...LOCALE_INFO];
  }

  private setLocaleInternal(locale: UILocale): void {
    if (LOCALES[locale]) {
      this.currentLocale = locale;
      this.currentStrings = LOCALES[locale];
    } else {
      this.currentLocale = 'vi';
      this.currentStrings = vi;
    }
  }

  private loadSavedLocale(): UILocale | null {
    try {
      const saved = localStorage.getItem(LOCALE_STORAGE_KEY);
      if (saved === 'vi' || saved === 'en') return saved;
    } catch {
      // localStorage unavailable
    }
    return null;
  }

  private saveLocale(locale: UILocale): void {
    try {
      localStorage.setItem(LOCALE_STORAGE_KEY, locale);
    } catch {
      // Ignore storage errors
    }
  }
}
